import React, { useEffect, useState } from "react";
import DeliveryGraph from "./deliveryGraph";
import { getHotStarFevUpdate, postWatchList } from "../action/api-services";
import { toast} from "react-toastify";
import moment from "moment";
import ModalSymbolBuy from "./modalSymbolBuy";
import { useSelector } from "react-redux";
import { AIPromptForStock1 } from "../utils/constants";



const StockAction = ({symbol, delivery, currentPrice, deliveryPer, hotStar, myFev, eventName, rowId, slPrice, gttPrice, date}) =>{

    const [paramsMeta, setParamsMeta] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [isHotStar, setIsHotStar] = useState(Number(hotStar));
    const [isMyFev, setIsMyFev] = useState(myFev);
    // const [isHotStar, setIsHotStar] = useState(undefined);
    // const [isMyFev, setIsMyFev] = useState(undefined);
    const userToken = useSelector((state) => state.userToken.value);


    const openModal = () => setModalShow(true);
    const closeModal = () => setModalShow(false);
    let holdSymbol = [];

    const holdingList = useSelector((state) => state.holdingList.value);
    if(window.location.pathname !== '/watchlist' && window.location.pathname !== '/pf'){
        holdSymbol = holdingList?.find(item => item.symbol === symbol);
    }

    
    useEffect(() => {
        setIsHotStar(hotStar);
    }, [hotStar]);

    useEffect(() => {
        setIsMyFev(myFev);
    }, [myFev]);


    const addWatchlistEvent = (e, symbol) =>{
        e.preventDefault();
        const strength_count = document.querySelector(`#${rowId}`)?.querySelector('.strength_count')?.textContent?.trim();        

        let payload = {
            'create_date'           : date? moment(date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
            'symbol'                : symbol,
            'method'                : eventName,
            'watchlist'             : 1,
            'watchlist_date'        : date? moment(date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
            'watchlist_price'       : currentPrice,
            'deliveryPer'           : deliveryPer,
            'strengthCount'         : strength_count?strength_count:'0/22',
            'sl_price'              : slPrice,
            'gtt_price'             : gttPrice,
            // 'portfolio'             => $data['portfolio']? $data['portfolio']:0,
            // 'buy_date'              => $data['buy_date']? $data['buy_date']:NULL,
            // 'buy_price'             => $data['buy_price']? $data['buy_price']:0.00,
            // 'sold_date'             => $data['sold_date']? $data['sold_date']:NULL,
            // 'sold_price'            => $data['sold_price']? $data['sold_price']:0.00,
            // 'unit_qty'              => $data['unit_qty']? $data['unit_qty']:0,
            // 'user'                  => $data['user']? $data['user']:'',
            // 'vendor'                => $data['vendor']? $data['vendor']:''
        };
    
        
        postWatchList(payload, userToken).then(function(response){
            // alert(response.data.status)
            if(response.data.status == false){
                toast.error("Duplicate Entry");
            }else{
                toast.success("Successfully added to watchlist");
            }  
        })

    } 

    const addPortfolioHandler = (e, symbol) =>{
        e.preventDefault();
        const strength_count = document.querySelector(`#${rowId}`)?.querySelector('.strength_count')?.textContent?.trim();        
        openModal(true);
        const itemMeta = {
                // 'id'                : item.id,
                'symbol'            : symbol,
                'watchlist_date'    : moment().format('YYYY-MM-DD'),
                'watch_price'       : currentPrice,
                'method'            : eventName,
                'deliveryPer'       : deliveryPer,
                'strengthCount'     : strength_count?strength_count:'0/22',
                'sl_price'          : slPrice,
                'gtt_price'         : gttPrice,
        }
        setParamsMeta(itemMeta);
    }

    const hotStartHandler = (e, symbol, hotStar) =>{
        e.preventDefault();
        let payload = {
            'symbol'        : symbol,
            'hotStar'       : parseInt(hotStar) === 1? 1 :0
        }
        getHotStarFevUpdate(payload, userToken).then(function (response) {
           if (response.data.data.id) {        
            
                setIsHotStar(Number(response.data.data.hotStar));
                // const tr = document.querySelector('.tr_' + response.data.data.id) || document.querySelector('.action_details_id_' + response.data.data.id);
                const id = response.data.data.id;
                const trs = document.querySelectorAll(`.tr_${id}, .action_details_id_${id}`);

                
                
          
                if (trs.length > 0) {
                     trs.forEach((tr) => {
                        const symbolCell = tr.querySelector("td.symbolName");
                        const actionList = tr.querySelector(".actionEllips ul");                      

                            if (response.data.data.hotStar === 0) {
                                    if (symbolCell) {
                                        const symbolHotStar = symbolCell.querySelector(".hotStar");
                                        if (symbolHotStar) symbolHotStar.remove();
                                    }

                                    const actionHotStar = actionList.querySelector(".hotStar");   
                                    if (actionHotStar) {
                                        setTimeout(() =>{
                                        const hotStarSpan = actionHotStar.querySelector(":scope > span");
                                        if (hotStarSpan) hotStarSpan?.remove();                                         
                                        }, 200)
                                    }
                                        

                            } else if (response.data.data.hotStar === 1) {
                                                                        

                                    const newSymbolHotStar = document.createElement("span");
                                    newSymbolHotStar.className = "hotStar";
                                    if(symbolCell){
                                        symbolCell.appendChild(newSymbolHotStar);
                                    }

                                    const hotStarLi = Array.from(actionList.querySelectorAll("li")).find(li => li.textContent.includes("Hot Star"));
                                    const hotStar = hotStarLi?.querySelector(".hotStar");

                                    if (hotStar) {
                                        setTimeout(() =>{
                                            const spans = hotStar.querySelectorAll(":scope > span");

                                            // Remove duplicates, keep first
                                            spans.forEach((span, index) => {
                                                if (index > 0) {
                                                    span.remove();
                                                }
                                            });

                                            // Add only if none exists
                                            if (spans.length === 0) {
                                                const newActionHotStarSpan = document.createElement("span");
                                                hotStar.appendChild(newActionHotStarSpan);
                                            }
                                        }, 200)
                                    }


                            }
                    });
                }
            }


        }).catch(function (err) {console.log("Error", err) });
        
    }

    const myFevHandler = (e, symbol, myFev) =>{
        e.preventDefault();
        let payload = {
            'symbol' : symbol,
            'myFev': myFev === 'Yes'? 1 : 0
        }
        getHotStarFevUpdate(payload, userToken).then(function (response) {
           if (response.data.data.id) {            
                const tr = document.querySelector('.tr_' + response.data.data.id);
                setIsMyFev(response.data.data.myFev);
                // console.log(response.data.data.id, response.data.data.myFev )
                // console.log("tr", tr)

                if (tr) {
                    const indices = tr.querySelector(".indices");
                    if (indices) {
                        let existingText = indices.textContent || '';
                        const newText = 'Fev';

                        if (response.data.data.myFev === 'Yes') {
                            // Add 'Fev' if not already present
                            if (!existingText.includes(newText)) {
                                indices.textContent = existingText + (existingText !== '' ? ', ' : '') + newText;
                            }
                        } else {
                            // Remove 'Fev' from existing text (with optional comma and space)
                            const cleanedText = existingText
                                .split(',')                          // split by comma
                                .map(item => item.trim())            // trim each
                                .filter(item => item !== newText)    // remove 'Fev'
                                .join(', ');
                            indices.textContent = cleanedText;
                        }
                    }

                }
            }


        }).catch(function (err) {console.log("Error", err) });
    }
    

    return(
        <React.Fragment>
        <div className="actionEllips">
            <ul key="action1">
                <li><a target="_blank" 
                    href={`https://www.google.com/ai?q=${AIPromptForStock1(symbol)}`}                
                    // href={`https://www.google.com/search?q=${symbol}+share+analyst+predictions+price+targets+trends+research+reports+FII+DII+smart+money+activity+chart+and+latest+news`}
                    >AI Mode</a></li>
                <li><a target="_blank" href={`https://www.google.com/search?q=NSE:${symbol}+stock+price`}>Google</a></li>
                <li><a target="_blank" href={`https://www.nseindia.com/get-quotes/equity?symbol=${symbol}`}>NSE</a></li>
                <li><a target="_blank" href={`https://in.tradingview.com/chart/?symbol=NSE%3A${symbol}`}>TradingView</a></li>
                <li><a target="_blank" href={`https://chartink.com/stocks-new?symbol=${symbol}`}>Chartink</a></li>
                <li><a target="_blank" href={`https://www.screener.in/company/${symbol}`}>Screener</a></li>
                
                {/* <li><a target="_blank" href={`https://intradayscreener.com/stocks/${symbol}`}>Intraday</a></li> */}
                {/* <li><a target="_blank" href={`https://groww.in/stocks/${symbol}`}>GLinK</a></li> */}
                <li><a href="#" onClick={(e) => addWatchlistEvent(e, symbol)} >Add WatchList {parseInt(holdSymbol?.watchlist) === 1? "(+)":""}</a></li>
                {window.location.pathname !== '/watchlist' && window.location.pathname !== '/pf' ? <li><a href="#" onClick={(e) => addPortfolioHandler(e, symbol)}>Add Portfolio {parseInt(holdSymbol?.portfolio) === 1? "(+)":""}</a>
                </li>: ''}
                <li className="details_hotStar"><a href="#" className="hotStar" onClick={(e) => hotStartHandler(e, symbol, isHotStar)}>Hot Star {Number(isHotStar) === 1?  <span></span> : ''}</a></li>
                <li className="details_myFev"><a href="#" className="myFev" onClick={(e) => myFevHandler(e, symbol, isMyFev)}>My Fev {isMyFev === 'Yes'?<span></span>:''}</a></li>
                
                
                {delivery === true? <li className="action_delivery_graph"><DeliveryGraph symbol={symbol}/></li>: ''}
                
                
            </ul>
        </div>

        <ModalSymbolBuy show={modalShow} onHide={closeModal}  paramsMeta={paramsMeta} newEntry={true} /> 
        </React.Fragment>
    )

}
export default StockAction;